import { PageHeader } from 'app/pages/account/userAccount/addOns/components/PageElements';
import { useOnClickOutside } from 'lib/utils';
import React from 'react';
import { Button } from 'react-covideo-common';
import { IoMdClose } from 'react-icons/io';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { Modal } from './Modal';

interface Field {
  id: number;
  firstName: string;
  lastName: string;
  selectable: boolean;
}

type RemoveUserProps = {
  handleModalClose: () => void;
  handleModalConfirm: () => void;
  user: Field;
  type: string;
};

export const ModalRemoveUser = ({
  handleModalClose,
  handleModalConfirm,
  user,
  type,
}: RemoveUserProps) => {
  const { t } = useTranslation();

  const ModalBody = styled.div`
    width: 592px;
    height: 196px;
  `;

  const ModalHeader = styled(PageHeader)`
    font-size: 18px;
    padding-right: 32px;
    margin-bottom: 16px;
    justify-content: space-between;
  `;

  const CloseButtonWrapper = styled.label`
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.neutral[40]};
    &:hover {
      cursor: pointer;
    }
  `;

  const ModalMessage = styled.div`
    margin: 0 32px 0 32px;
  `;

  const ButtonsWrapper = styled.section`
    display: flex;
    flex-direction: row-reverse;
    margin-top: 48px;
    margin-right: 32px;
    button {
      margin-left: 15px;
    }
  `;

  const { ref } = useOnClickOutside(handleModalClose);

  return (
    <Modal>
      <div ref={ref}>
        <ModalBody>
          <ModalHeader>
            {t('Remove {{firstName}} {{lastName}} from {{type}}?', {
              firstName: user.firstName,
              lastName: user.lastName,
              type,
            })}
            <CloseButtonWrapper>
              <IoMdClose size={24} onClick={handleModalClose} />
            </CloseButtonWrapper>
          </ModalHeader>
          <ModalMessage>
            {t('{{firstName}} {{lastName}} will lose access to {{type}}', {
              firstName: user.firstName,
              lastName: user.lastName,
              type,
            })}
          </ModalMessage>
          <ButtonsWrapper>
            <Button
              text={t('Remove User')}
              variant='red'
              onClick={handleModalConfirm}
            />
          </ButtonsWrapper>
        </ModalBody>
      </div>
    </Modal>
  );
};
